import { isSupported } from 'firebase/messaging';

import { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Loading from 'components/global/Loading';
import Typography from 'components/global/Typography';

import useAlert from 'hooks/useAlert';
import useRefreshToken from 'hooks/useRefreshToken';

import axios from 'services/axios';
import { REGISTER } from 'services/consts';
import { deleteFCMToken } from 'services/firebase';

import AppLogger from 'utils/AppLogger';
import FirebaseAuthService from 'utils/FirebaseAuthService';
import PATHS from 'utils/paths';

import * as S from './SigninWithGoogle.styled';

const SigninWithGoogle = ({ disabled }) => {
	const [loading, setLoading] = useState(false);

	const refreshAccess = useRefreshToken();
	const navigate = useNavigate();
	const { state } = useLocation();
	const { showError } = useAlert();
	const [searchParams] = useSearchParams();

	const handleGoogleLogin = async () => {
		setLoading(true);
		try {
			const userRef = await FirebaseAuthService.loginWithGoogle();
			const response = await axios.post(REGISTER.CHECK_REGISTER, {
				UID: userRef.user.uid,
				email: userRef.user.email,
				refreshToken: userRef.user.stsTokenManager.refreshToken
			});

			const isRegistered = response.data.registered;

			// remove FCM token
			try {
				await isSupported().then(async (isSupported) => {
					isSupported && (await deleteFCMToken());
				});
			} catch {
				// do nothing
			}

			// if user is already registered to our server set the access token to redux
			if (isRegistered) {
				await refreshAccess(userRef.user.stsTokenManager.refreshToken);
				await FirebaseAuthService.logoutUser();

				if (state?.redirectTo) {
					navigate(state.redirectTo.pathname + state.redirectTo.search);
				} else {
					navigate(PATHS.BASE);
				}
			} else {
				navigate(
					{ pathname: PATHS.REGISTER_WITH_PROVIDER, search: searchParams.toString() },
					{ state: { registered: false, from: 'signInWithGoogle' } }
				);
			}
		} catch (error) {
			showError({
				header: 'unableToLogin',
				message: 'googleAuthFailed'
			});
			AppLogger.error(error);
		}
		setLoading(false);
	};

	return (
		<>
			<Button
				fullWidth
				size="large"
				loading={loading}
				disabled={disabled}
				color="primary"
				variant="transparent"
				onClick={handleGoogleLogin}
				css={S.GoogleButtonCss}>
				<Image
					height="unset"
					width="2rem"
					url={'https://storage.googleapis.com/tryoto-public/public/assets/images/GoogleLogo.svg'}
				/>
				<Typography className="button-text" variant="p2">
					continueWithGoogle
				</Typography>
			</Button>

			{loading && <Loading />}
		</>
	);
};

export default SigninWithGoogle;
